import styled from 'styled-components'
import { Icon } from 'ui/styled'

export const CatalogHeader = styled.div`
  align-items: center;
  display: flex;
  gap: 16px;
  justify-content: space-between;
  padding-top: 4px;

  @media (max-width: 640px) {
    flex-direction: column;
  }
`

export const CatalogTitle = styled.div`
  color: ${({ theme }) => theme.palette.colors.text};
  font-size: 15px;
  font-weight: 800;
`

export const SelectedCount = styled.div`
  color: ${({ theme }) => theme.palette.colors.muted};
  font-size: 12px;
  margin-top: 4px;
`

export const CatalogDescription = styled.p`
  color: ${({ theme }) => theme.palette.colors.muted};
  font-size: 13px;
  line-height: 1.45;
  margin: 8px 0 0;
`

export const CatalogActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`

const CatalogAction = styled.button`
  background: ${({ theme }) => theme.palette.colors.buttonGhost};
  border: 1px solid ${({ theme }) => theme.palette.colors.borderSoft};
  border-radius: 8px;
  color: ${({ theme }) => theme.palette.colors.text};
  cursor: pointer;
  font-size: 12px;
  font-weight: 700;
  min-height: 34px;
  padding: 7px 10px;

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.palette.blue.main};
    outline-offset: 2px;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: .45;
  }
`

export const SelectVisibleButton = styled(CatalogAction)``
export const ClearButton = styled(CatalogAction)``

export const FilterGrid = styled.div`
  display: grid;
  gap: 12px;
  grid-template-columns: minmax(0, 1.35fr) minmax(220px, .65fr);
  margin-top: 14px;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`

export const CatalogList = styled.div`
  border: 1px solid ${({ theme }) => theme.palette.colors.borderSoft};
  border-radius: 10px;
  margin-top: 12px;
  max-height: min(34vh, 320px);
  overflow-y: auto;
  padding: 6px 12px;
`

export const CatalogRow = styled.div`
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.palette.colors.borderSoft};
  display: flex;
  gap: 12px;
  justify-content: space-between;
  min-height: 54px;
  background: ${p => p.$allowed ? p.theme.palette.colors.buttonGhost : 'transparent'};
  flex-wrap: wrap;
  padding: 6px 0;

  & > :first-child { flex: 1; min-width: 160px; }

  &:last-child {
    border-bottom: 0;
  }
`

export const AccessStatus = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  color: ${p => p.$allowed ? p.theme.palette.success.main : p.theme.palette.colors.muted};
  font-size: 11px;
  font-weight: 600;
`

export const LockIcon = styled(Icon)`
  width: 16px;
  height: 16px;
`

export const TypeLabel = styled.span`
  color: ${({ theme }) => theme.palette.colors.subdued};
  flex-shrink: 0;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
`

export const CatalogMessage = styled.div`
  color: ${({ error, theme }) => error ? theme.palette.error.main : theme.palette.colors.muted};
  font-size: 13px;
  padding: 22px 8px;
  text-align: center;
`
